import { LOAD_USER_INFO } from '../actionTypes';

const loadUserInfo = payload => ({
  type: LOAD_USER_INFO,
  payload,
});

export default loadUserInfo;



// WEBPACK FOOTER //
// ./src/redux/actions/userInfo.js